<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">

          <p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">{{name}}</span></p>
          <p style="text-align: left; margin-bottom : 20px; margin-top: 30px;line-height: 32px;"><span style="margin-left: 36px; font-size: 16px;">{{desc}}</span></p>
          <div id="Layer1">
            <img src="../../assets/img/zxs.png" width="832" height="428" border="0" usemap="#Map">
            <map name="Map">
<!--              <area shape="rect" coords="11,206,110,296" href="/service8">-->
<!--              <area shape="rect" coords="81,70,171,160" href="/service6">-->
<!--              <area shape="rect" coords="211,5,311,105" href="/service7">-->
<!--              <area shape="rect" coords="345,70,446,160" href="/service10">-->
<!--              <area shape="rect" coords="395,206,495,296" href="/service9">-->

              <area v-for="item in kyuserList"
                  :key="item"
                    shape="rect" :coords="item.coords" :href="item.linkUrl">
            </map>
          </div>

          <!-- 在站科研用户 -->
<!--          <div class="b-kyuserList clearfix">-->
<!--            <ul class="clearfix">-->
<!--              <li v-for="item in kyuserList"-->
<!--                  :key="item">-->
<!--                <a :href="item.linkUrl">-->
<!--                <div class="b-item-link"  :style="item.backgroundColor">-->
<!--                    <div class="b-item-name">{{ item.name }}</div>-->
<!--                </div>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
          <div style="height: 50px;">

          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      kyuserList: [],
      id: "",
      name: "",
      desc: "",
    };
  },
  mounted () {
    // 在站科研用户
    this.id = this.$route.query.id;

    this.name = "技术服务";
    this.desc = "设施根据转化医学研究目标、服务对象和技术服务类型，首批建设生物医学影像技术中心、  模式动物技术中心、新药创制技术中心、生物医学数据技术中心、生物医学制造技术中心和临床验证技术中心等专业技术中心，打造服务品牌，为转化医学研究提供一站式实验技术体系服务，促进科研成果快速临床转化。";
    this.kyuserList = [
      {
        coords: "5,55,221,100",
        linkUrl: '/service8'
      },
      {
        coords: "5,110,221,152",
        linkUrl: '/service6'
      },
      {
        coords: "5,162,221,205",
        linkUrl: '/service7'
      },
      {
        coords: "5,215,221,258",
        linkUrl: '/service10'
      },
      {
        coords: "5,268,221,310",
        linkUrl: '/service9'
      },

      {
        coords: "311,5,551,55",
        linkUrl: '/service4'
      },
      {
        coords: "311,65,551,115",
        linkUrl: '/service'
      },
      {
        coords: "311,125,551,175",
        linkUrl: '/service3'
      },
      {
        coords: "311,190,551,240",
        linkUrl: '/service2'
      },
      {
        coords: "311,252,551,302",
        linkUrl: '/service0'
      },
      {
        coords: "311,315,551,365",
        linkUrl: '/service13'
      }
    ];
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
/* 在站科研用户 */
.b-kyuserList ul {
  margin: 0 30px;
  height: -webkit-fill-available;
  li {
    width: 230px;
    float: left;
    margin-left: 50px;
    margin-right: 40px;
    margin-top: 30px;
    margin-bottom: 20px;
    .b-item-link {
      margin: 0 8px;
      border: 1px solid gray;
      border-radius: 20px;
      display: block;
      padding: 20px 10px;
      height: 180px;
      overflow: hidden;
    }
    .b-item-name {
      text-align: center;
      color: #fff;
      font-size: 18px;
      /* font-weight: bold; */
      height: 25px;
      line-height: 25px;
      word-wrap: break-word;
      word-break: normal;
      margin-top: 60px;
      &:hover {
        color: #fff;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/zxs/index.vue